export { default as ClipboardCheckSolidIcon } from './ClipboardCheckSolidIcon';
